import { usePremiumBenefitsList } from 'app/components/subscriptions/dialogs/ManageYourPlanDialog';
import {
  PremiumPlanInfoTooltip,
  SubscriptionInfoCard,
  SubscriptionPlanBenefitsList,
} from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/components';
import { SubscriptionInfo } from 'app/hooks/subscriptions/useSubscriptionInfo';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import './PremiumPlanView.less';

interface Props {
  equipment: IEquipmentEntry;
  subscriptionInfo: SubscriptionInfo;
}

export default function PremiumPlanView({
  equipment,
  subscriptionInfo,
}: Props) {
  const { t } = useTranslation();
  const benefits = usePremiumBenefitsList();

  return (
    <>
      <SubscriptionInfoCard
        equipment={equipment}
        subscriptionInfo={subscriptionInfo}
        classname="premium-plan-view__subscription-info-card"
      />

      <div className="premium-plan-view__benefits">
        <h3 className="premium-plan-view__benefits-title">
          {t(
            'subscriptions.manage_your_plan.premium_telematics_plan.benefits.title',
          )}
          <PremiumPlanInfoTooltip />
        </h3>

        <p className="premium-plan-view__benefits-description">
          {t(
            'subscriptions.manage_your_plan.premium_telematics_plan.benefits.subtitle',
          )}
        </p>

        <SubscriptionPlanBenefitsList items={benefits} />
      </div>
    </>
  );
}
